import api from "../api";
import func from "../func";

let folders = {};
let loading = false;

export default {
    async search(id) {
        if (!func.isDefined(folders[id])) {
            if (loading) { // wait
                return func.sleep(250).then(() => {
                    return this.search(id);
                })
            }
            loading = true;
            folders[id] = await api.v1.album.folder.search(id)
                .finally(() => loading = false);
        }
        return folders[id];
    },
    async option(id) {
        let options = [];
        let res = await this.search(id);
        res.data.forEach(folder => {
            options.push({value: folder.id, label: folder.info.name});
        });
        return options;
    },
    create(id, args) {
        return api.v1.album.folder.create(id, args).then(() => delete folders[id]);
    },
    delete(id, memberId, role) {
        return api.v1.album.folder.delete(id, memberId, role).then(() => delete folders[id]);
    },
    update(id, folderId, args) {
        return api.v1.album.folder.update(id, folderId, args).then(() => delete folders[id]);
    }
}
